import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // 1. Mientras el AuthContext verifica si hay una sesión guardada,
    // es importante no renderizar nada para evitar un "parpadeo" de la pantalla.
    if (isLoading) {
        // Puedes mostrar un spinner de carga a pantalla completa aquí si lo deseas.
        return <div>Verificando sesión...</div>; 
    }

    // 2. Si la verificación terminó y el usuario NO está autenticado,
    // lo redirigimos a la página de login.
    // Guardamos la página a la que intentaba ir (`location`) para que,
    // después de un login exitoso, podamos redirigirlo de vuelta.
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Si el usuario está autenticado, simplemente mostramos el contenido
    // protegido que está dentro de este componente (en tu caso, el RootLayout).
    return <>{children}</>;
};

export default ProtectedRoute;